export default __webpack_public_path__ + "static/media/thoughtful.3301a15b.png";